import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { MailCheck } from 'lucide-react';
import MemberLayout from '../../components/MemberLayout';
import { Field, Spinner } from '../../components/ui';
import api, { errMsg } from '../../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/public/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <MemberLayout narrow>
      <div className="card p-7">
        {sent ? (
          <div className="text-center">
            <MailCheck size={44} className="mx-auto text-green-600" />
            <h1 className="mt-3 text-xl font-semibold text-navy-900">Check your email</h1>
            <p className="mt-2 text-sm text-gray-600">If <strong>{email}</strong> is registered, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login" className="btn-outline mt-6">Back to log in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-bold text-navy-900">Forgot password</h1>
            <p className="mt-1 text-sm text-gray-600">Enter the email you registered with and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-5 space-y-4">
              <Field label="Email"><input type="email" className="input" required value={email} onChange={e => setEmail(e.target.value)} /></Field>
              <button disabled={busy} className="btn-primary w-full py-2.5">{busy && <Spinner size={16} />}Send reset link</button>
            </form>
            <p className="mt-5 text-center text-sm"><Link to="/login" className="text-navy-700 hover:underline">Back to log in</Link></p>
          </>
        )}
      </div>
    </MemberLayout>
  );
}
